export function thumbRoundSize(size: number): number {
    if (size <= 300) return 300;
    if (size <= 500) return 500;
    if (size <= 800) return 800;
    if (size <= 1280) return 1280;
    return 1600;
}
